import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import { PROPOSAL_TYPE } from "../../state/proposal/ProposalType"
import LabelHelper from "../LabelHelper"

type OwnProps = {
    documentType: PROPOSAL_TYPE
    sendEmail: boolean
    day: number
    loading: boolean
    onUpdate: (days: number) => void
}

const DayInput = (props: OwnProps & IntlProps) => {
    const MAX_NUMBERS_OF_DAYS_IN_ADVANCE = 31
    const getDayInput = (): React.ReactElement => {
        const daysInput = (
            <input
                style={{ width: "4em" }}
                className="form-control d-inline"
                min={0}
                max={MAX_NUMBERS_OF_DAYS_IN_ADVANCE}
                defaultValue={0}
                type={"number"}
                value={props.day}
                name={"createDaysInAdvance"}
                disabled={props.loading}
                onChange={({ target }) =>
                {
                    target.value = Math.min(Number(target.value), MAX_NUMBERS_OF_DAYS_IN_ADVANCE).toString()
                    props.onUpdate(Number(target.value))}
                }
                onFocus={({ target }) => target.select()}
            />
        )

        const daysSelect = (
            <select
                className="custom-select w-auto"
                name="dayOfMonth"
                value={props.day}
                disabled={props.loading}
                onChange={({ target }) => props.onUpdate(Number(target.value))}
            >
                {/*
                    This beauty of an array lists all the days of the month when we can reliably send a recurring document.
                    Since we need to account for February, we cannot send recurring documents on the 29th, 30th, or 31st
                    day of the month. Therefore, we only list 1 to 28 and an option for the last day of the month (which
                    can be 29, 30, or 31 depending on the month).
                */}
                {[...Array(28).keys(), 30].map(day => (
                    <option key={day + 1} value={day + 1}>
                        {LabelHelper.getDayOfMonthLabel(props.intl, day + 1)}
                    </option>
                ))}
            </select>
        )

        if (props.sendEmail) {
            return props.documentType === PROPOSAL_TYPE.ACCOUNT_STATEMENT ? (
                <FormattedMessage
                    id="contacts.statement.recurring.options.input_day_of_month_send"
                    defaultMessage="Send statement on the {input} of every month"
                    values={{
                        input: daysSelect
                    }}
                />
            ) : (
                <p className="mb-0">
                    <FormattedMessage
                        id="invoice.recurring.options.input_send_days_in_advance"
                        defaultMessage="Send invoice {input} day(s) in advance"
                        values={{
                            input: daysInput
                        }}
                    />
                </p>
            )
        }

        return props.documentType === PROPOSAL_TYPE.ACCOUNT_STATEMENT ? (
            <FormattedMessage
                id="contacts.statement.recurring.options.input_day_of_month_create"
                defaultMessage="Create statement on the {input} of every month"
                values={{
                    input: daysSelect
                }}
            />
        ) : (
            <p className="mb-0">
                <FormattedMessage
                    id="invoice.recurring.options.input_create_days_in_advance"
                    defaultMessage="Create invoice {input} day(s) in advance"
                    values={{
                        input: daysInput
                    }}
                />
                <small className="form-text text-muted">
                    <FormattedMessage
                        id="invoice.recurring.options.input_create_days_in_advance_note"
                        defaultMessage="Note: If the days in advance falls on a date
                        that is prior to today's calendar date,
                        the first invoice will be sent on the invoice date."
                    />
                </small>
            </p>
        )
    }

    return getDayInput()
}

export default injectIntl(DayInput)


// WEBPACK FOOTER //
// ./src/common/recurring-options-dropdown/DayInput.tsx